import { render, staticRenderFns } from "./payers.vue?vue&type=template&id=26de2de2"
import script from "./payers.vue?vue&type=script&lang=js"
export * from "./payers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports